function checkNodeType(c) {
  return c.nodeType === "heading-2";
}

function recursiveSectionSplit(sections = [], nodes = []) {
  // If no nodes, return
  if (nodes == null || nodes.length === 0) return [];
  // If no more section headers, batch left over nodes
  if (nodes.slice(1).findIndex(checkNodeType) === -1) return [...sections, [...nodes]];
  // Otherwise continue moving through
  return recursiveSectionSplit(
    [...sections, [...nodes.slice(0, nodes.slice(1).findIndex(checkNodeType) + 1)]],
    nodes.slice(nodes.slice(1).findIndex(checkNodeType) + 1)
  );
}

export default function richTextNodesInSections(json) {
  if (json == null || json.content == null) return [];
  const { content } = json;
  // Check if we even have a header
  if (content.findIndex(checkNodeType) === -1) return [content];
  // If so run!
  const sections = content.slice(0, content.findIndex(checkNodeType));
  const nodes = content.slice(content.findIndex(checkNodeType));
  // Iterate through
  return recursiveSectionSplit([sections], nodes);
}
